import React, { useState } from "react";
import Modal from "./Modal";
import "./CategoryModal.css";

function CategoryModal({ categories, onClose, onCreate, onDelete }) {
  const [newCategoryName, setNewCategoryName] = useState("");
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState("");

  const handleCreate = async (e) => {
    e.preventDefault();
    setError("");
    setCreating(true);

    try {
      await onCreate(newCategoryName);
      setNewCategoryName("");
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create category");
    } finally {
      setCreating(false);
    }
  };

  const handleDelete = async (categoryId) => {
    try {
      await onDelete(categoryId);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to delete category");
    }
  };

  return (
    <Modal onClose={onClose} title="Manage Categories">
      <div className="category-modal">
        {error && <div className="error-message">{error}</div>}

        <form
          onSubmit={handleCreate}
          className="category-form"
          id="category-form"
          name="category-form"
        >
          <div className="form-group">
            <label htmlFor="category-name" className="form-label">
              New Category
            </label>
            <div className="category-input-row">
              <input
                type="text"
                id="category-name"
                name="category-name"
                className="input"
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                placeholder="Enter category name"
              />
              <button
                type="submit"
                className="btn"
                disabled={creating || !newCategoryName.trim()}
                id="create-category-button"
                name="create-category-button"
              >
                {creating && <span className="spinner"></span>}
                {creating ? "Adding..." : "Add"}
              </button>
            </div>
          </div>
        </form>

        <div className="categories-list">
          <h3 className="categories-list-title">Existing Categories</h3>
          {categories.length === 0 ? (
            <p className="no-categories">No categories yet</p>
          ) : (
            <div className="category-items">
              {categories.map((category) => (
                <div
                  key={category.id}
                  className="category-item"
                  id={`category-${category.id}`}
                >
                  <span className="category-name">{category.name}</span>
                  <button
                    className="category-delete-btn"
                    onClick={() => handleDelete(category.id)}
                    id={`delete-category-${category.id}`}
                    name={`delete-category-${category.id}`}
                    title="Delete category"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button className="btn" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default CategoryModal;
